import { INSTALLATION_ADDRESS } from '@/constants/installationAddress';
import { PERSONAL_DATA } from '@/constants/personalData';
import { ORDER_SUMMARY } from '@/constants/orderSummary';
import { getGMapsAddressString } from '@/utils/GMapsUtils';


export const getOrionInfoTextByAlias = (alias, orionInfo) => {
  return (
    orionInfo?.find(item => item?.alias?.includes(alias))?.texts
  );
};

const appendAddressPart = (address, part) => {
  return part ? `${address}${address ? ', ' : ''}${part}` : address;
};
export const calculateAddress = (
  formData,
  addressType,
  view = false,
  isManualAddress
) => {
  let address = '';
  if (addressType) {
    const horizontalAddress =
      formData[addressType.HORIZONTAL_ADDRESS.ID]?.label || '';
    const verticalAddress =
      formData[addressType.VERTICAL_ADDRESS.ID]?.label || '';
    const fullAddress = formData[addressType.ADDRESS.ID] || '';
    const streetNumber = formData[addressType.STREET_NUMBER.ID] || '';
    const floor = formData[addressType.FLOOR.ID] || '';
    const door = formData[addressType.DOOR.ID] || '';
    address = appendAddressPart(address, horizontalAddress);
    address = appendAddressPart(address, verticalAddress);
    if (view && !address) {
      address = fullAddress?.formattedAddress || address;
      address = appendAddressPart(address, streetNumber);
      address = appendAddressPart(address, floor);
      address = appendAddressPart(address, door);
    } else if (!address) {
      address = appendAddressPart(
        address,
        fullAddress && getGMapsAddressString(fullAddress?.value)
      );
      address = appendAddressPart(
        address,
        streetNumber ? `Número: ${streetNumber}` : ''
      );
      address = appendAddressPart(address, floor ? `Planta: ${floor}` : '');
      address = appendAddressPart(address, door ? `Puerta: ${door}` : '');
    }
  }
  if (isManualAddress) {
    const horizontal =
      formData[addressType.HORIZONTAL_ADDRESS.ID]?.label ||
      formData[addressType.HORIZONTAL_ADDRESS.ID];
    address = `Direccion no encontrada: ${horizontal}`;
  }
  return address;
};

export const getInstallationAddressInfoFromForm = (
  formData,
  isManualAddress
) => {
  const payload = {};
  const geographicSiteId = formData[INSTALLATION_ADDRESS.HORIZONTAL_ADDRESS.ID]
    ?.full
    ? formData[INSTALLATION_ADDRESS.HORIZONTAL_ADDRESS.ID]?.value || null
    : formData[INSTALLATION_ADDRESS.VERTICAL_ADDRESS.ID]?.value || null;
  payload.geographicSiteId = !isManualAddress ? geographicSiteId : null;
  payload.installationAddress = calculateAddress(
    formData,
    INSTALLATION_ADDRESS,
    false,
    isManualAddress
  );
  if (!isManualAddress) {
    payload.postalCode =
      formData[INSTALLATION_ADDRESS.HORIZONTAL_ADDRESS.ID]?.postalCode;
    payload.lineCoverage = formData[INSTALLATION_ADDRESS.HORIZONTAL_ADDRESS.ID]
      ?.full
      ? formData[INSTALLATION_ADDRESS.HORIZONTAL_ADDRESS.ID]?.lineCoverage
      : formData[INSTALLATION_ADDRESS.VERTICAL_ADDRESS.ID]?.lineCoverage;
  }
  return payload;
};

export const transformFormDataInfoToPayload = ({
  formData,
  isManualAddress,
}) => {
  const payload = {};
  let address = {};
  if (formData) {
    payload.legalTermsAcceptance =
      formData[ORDER_SUMMARY.TERMS_AND_CONDITIONS_CHECK.ID];
    address = getInstallationAddressInfoFromForm(formData, isManualAddress);
    payload.contactEmail = formData[PERSONAL_DATA.EMAIL.ID];
    payload.contactPhone = formData[PERSONAL_DATA.CONTACT_PHONE.ID]?.replace(
      /\s/g,
      ''
    );
    if (formData[PERSONAL_DATA.MODAL_CONTACT_PHONE.ID]) {
      payload.installationContactPhone = formData[
        PERSONAL_DATA.MODAL_CONTACT_PHONE.ID
      ]?.replace(/\s/g, '');
    }
  }
  return {
    ...payload,
    ...address,
  };
};
